import { render, staticRenderFns } from "./ContentPlaceholdersImg.vue?vue&type=template&id=32a6ed80"
import script from "./ContentPlaceholdersImg.vue?vue&type=script&lang=js"
export * from "./ContentPlaceholdersImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports